module.exports = __webpack_public_path__ + "static/img/2.25e07b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/2.png
// module id = dwXQ
// module chunks = 0